"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PreviewVideoContainer = /** @class */ (function (_super) {
    __extends(PreviewVideoContainer, _super);
    function PreviewVideoContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.videoRef = null;
        _this.videoPauseTimeout = null;
        _this.playbackFinishedTimeout = null;
        _this.state = {
            startTime: 0,
            stopTime: 0,
            buffering: true,
        };
        _this.setVideoRef = function (videoRef) {
            _this.videoRef = videoRef;
        };
        _this.preventContextMenu = function (event) {
            event.preventDefault();
        };
        _this.onError = function () {
            _this.props.onError(_this.videoRef ? _this.videoRef.error : null);
        };
        _this.stopPlaying = function (stopTime) { return function () {
            if (_this.videoRef != null) {
                _this.videoRef.pause();
                _this.videoRef.currentTime = stopTime;
            }
        }; };
        _this.checkBuffering = function () {
            var buffering = _this.isBuffering(_this.state.startTime, _this.state.stopTime);
            if (_this.state.buffering !== buffering) {
                _this.setState({ buffering: buffering });
                _this.props.onBufferChange(buffering);
            }
        };
        return _this;
    }
    PreviewVideoContainer.prototype.isBuffering = function (startTime, stopTime) {
        if (this.videoRef == null) {
            return true;
        }
        for (var index = 0; index < this.videoRef.buffered.length; index++) {
            if (this.videoRef.buffered.start(index) <= startTime && this.videoRef.buffered.end(index) >= stopTime) {
                return false;
            }
        }
        return true;
    };
    PreviewVideoContainer.prototype.playNextStep = function () {
        var _this = this;
        if (this.videoRef == null) {
            return;
        }
        if (this.state.stopTime > this.state.startTime) {
            if (this.props.jumpToFrame) {
                this.videoRef.currentTime = this.state.stopTime;
            }
            else {
                var stepTimePeriod = (this.state.stopTime - this.state.startTime) * 1000;
                this.videoPauseTimeout = window.setTimeout(this.stopPlaying(this.state.stopTime), stepTimePeriod);
                this.playbackFinishedTimeout = window.setTimeout(function () { return _this.props.onPlayingStepFinished(); }, stepTimePeriod - 500);
                this.videoRef.play();
            }
        }
        else {
            this.videoRef.currentTime = this.state.stopTime;
        }
    };
    PreviewVideoContainer.prototype.updateVideoPosition = function () {
        if (this.videoPauseTimeout != null) {
            clearTimeout(this.videoPauseTimeout);
        }
        if (this.playbackFinishedTimeout != null) {
            clearTimeout(this.playbackFinishedTimeout);
        }
        if (this.videoRef != null) {
            this.videoRef.pause();
        }
        if (!this.state.buffering) {
            this.playNextStep();
        }
    };
    PreviewVideoContainer.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.step === nextProps.step
            && this.props.jumpToFrame === nextProps.jumpToFrame
            && this.props.templatePreviewUrl === nextProps.templatePreviewUrl) {
            return;
        }
        var startTime = nextProps.stepTimes[this.props.step];
        var stopTime = nextProps.stepTimes[nextProps.step];
        var buffering = this.isBuffering(startTime, stopTime);
        this.setState({ startTime: startTime, stopTime: stopTime, buffering: buffering });
        this.props.onBufferChange(buffering);
    };
    PreviewVideoContainer.prototype.componentDidUpdate = function () {
        this.updateVideoPosition();
    };
    PreviewVideoContainer.prototype.componentWillUnmount = function () {
        if (this.videoPauseTimeout != null) {
            clearTimeout(this.videoPauseTimeout);
        }
        if (this.playbackFinishedTimeout != null) {
            clearTimeout(this.playbackFinishedTimeout);
        }
    };
    PreviewVideoContainer.prototype.render = function () {
        var videoCss = this.props.isBlurred ? { filter: 'blur(5px)' } : {};
        var _a = this.props, width = _a.width, height = _a.height;
        return (React.createElement("video", { width: width || "100%", height: height || "100%", preload: this.props.preloadVideo ? 'auto' : undefined, ref: this.setVideoRef, style: videoCss, onContextMenu: this.preventContextMenu, onError: this.onError, onProgress: this.checkBuffering, onCanPlay: this.checkBuffering, poster: this.props.templateThumbnailUrl },
            React.createElement("source", { type: "video/mp4", src: this.props.templatePreviewUrl })));
    };
    return PreviewVideoContainer;
}(React.PureComponent));
exports.PreviewVideoContainer = PreviewVideoContainer;
//# sourceMappingURL=PreviewVideoContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prezi/template-preview-lite/dist/PreviewVideoContainer.js
// module id = 149
// module chunks = 0